/* eslint-disable */

import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { loadStripe } from "@stripe/stripe-js";
import { Elements, useElements, useStripe } from "@stripe/react-stripe-js";
import { PaymentElement } from "@stripe/react-stripe-js";

import { fetchGraphQL } from "../../services/api-raindrop";
import { isLocalEnvironment } from "../../services/environment.js";
import { Size } from "../../logic/enums.ts";
import {
  STRIPE_PUBLISHABLE_KEY,
  STRIPE_CLIENT_SECRET_FAKE,
  URL_RAINDROP,
} from "../../services/constants.js";

import RaindropLoadingElement from "../raindrop-loading-element/raindrop-loading-element";
import RaindropButton, {
  ButtonStyle,
} from "../raindrop-button/raindrop-button.tsx";
import RaindropCard from "../raindrop-card/raindrop-card.tsx";

export enum StripeIntent {
  SetupIntent = "setup-intent",
  PaymentIntent = "payment-intent",
}

const NotUsingStripeLocallyComponent = () => {
  return <div>RD-2354 - Not using stripe locally</div>;
};

const StripePaymentForm = ({
  intent = StripeIntent.SetupIntent,
  onConfirmCallback = () => {},
  onBackCallback = () => {},
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmitSetupIntent = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    if (!stripe || !elements) {
      return;
    }

    const result = await stripe.confirmSetup({
      elements: elements,
      redirect: "if_required",
      confirmParams: {
        return_url: URL_RAINDROP,
      },
    });

    if (result.error) {
      console.error("🔴 (RD-368) - ", result.error);
      setIsSubmitting(false);
      return;
    }

    const setupIntent = result.setupIntent;

    const paymentMethodId = setupIntent.payment_method;

    const mutationResult = await fetchGraphQL(`
      mutation {
        addPaymentMethod(
          stripePaymentMethodId: "${paymentMethodId}"
        ) {
          id
        }
      }
    `);

    if (mutationResult.errors) {
      console.error("🔴 (RD-368) - ", mutationResult.errors);
    }

    onConfirmCallback();
    setIsSubmitting(false);
  };

  const onSubmitPaymentIntent = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    if (!stripe || !elements) {
      return;
    }

    const result = await stripe.confirmPayment({
      elements: elements,
      redirect: "if_required",
      confirmParams: {
        return_url: URL_RAINDROP,
      },
    });

    if (result.error) {
      console.error("🔴 (RD-368) - ", result.error);
      setIsSubmitting(false);
      return;
    }

    const paymentIntent = result.paymentIntent;

    const paymentMethodId = paymentIntent.payment_method;

    const mutationResult = await fetchGraphQL(`
      mutation {
        addPaymentMethod(
          stripePaymentMethodId: "${paymentMethodId}"
        ) {
          id
        }
        stripeProcessPaymentIntent(
          stripePaymentIntentId: "${paymentIntent.id}"
        ) 
        
      }
    `);

    if (mutationResult.errors) {
      console.error("🔴 (RD-368) - ", mutationResult.errors);
    }
    onConfirmCallback();
    setIsSubmitting(false);
  };

  const onBack = async (event) => {
    onBackCallback();
    navigate("/raindrop");
  };

  return (
    <div className="flex flex-col h-full  w-full gap-4 ">
      <RaindropCard>
        <div className="flex flex-col gap-2 w-full h-full overflow-y-auto no-scrollbar">
          <PaymentElement />
        </div>
      </RaindropCard>

      <div
        className={
          "flex flex-row gap-8 h-fit w-full items-center justify-center "
        }
      >
        <RaindropButton
          title={"Set up Later"}
          onClick={onBack}
          style={ButtonStyle.Secondary}
          size={Size.Large}
          isFluid={true}
        />
        <RaindropButton
          // icon={"fa-lock"}
          title={"Confirm"}
          onClick={
            intent === StripeIntent.PaymentIntent
              ? onSubmitPaymentIntent
              : onSubmitSetupIntent
          }
          style={ButtonStyle.Primary}
          isLoading={isSubmitting}
          size={Size.Large}
          isFluid={true}
        />
      </div>
    </div>
  );
};

const RaindropCardStripe = ({
  stripeClientSecret = "",
  intent = StripeIntent.SetupIntent,
  onConfirmCallback = () => {},
  onBackCallback = () => {},
}) => {
  const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY).catch((e) => {
    console.log(
      "(RD-435) It's okay, stripe failed, probably because you're not connected to the internet"
    );
  });

  if (!stripeClientSecret) {
    return <RaindropLoadingElement />;
  }

  if (
    stripeClientSecret === STRIPE_CLIENT_SECRET_FAKE &&
    isLocalEnvironment()
  ) {
    return <NotUsingStripeLocallyComponent />;
  }

  let theme = "light";
  if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
    theme = "night";
  }

  const options = {
    clientSecret: stripeClientSecret,
    appearance: {
      theme: theme,
      variables: {
        colorPrimary: "#EF5FA7",
      },
    },
  };

  return (
    <div className="flex flex-col w-full gap-2  items-center justify-center ">
      <Elements stripe={stripePromise} options={options}>
        <StripePaymentForm
          intent={intent}
          onBackCallback={onBackCallback}
          onConfirmCallback={onConfirmCallback}
        />
      </Elements>
    </div>
  );
};

export default RaindropCardStripe;
